import { SelectOptionTypes } from "../../../../components/Input";

export const FORM_ID = "savings-goal-form";

export const MODE_OPTIONS: SelectOptionTypes[] = [
  { label: "Reach a total balance", value: "BALANCE" },
  { label: "Save an amount this year", value: "FLOW" },
];

export const modeOptionOf = (mode: string) =>
  MODE_OPTIONS.find((option) => option.value === mode) ?? MODE_OPTIONS[0];

// Shorter labels for the mobile segmented control, mapped back to MODE_OPTIONS
// by value on change.
export const MODE_SEGMENTS: SelectOptionTypes[] = [
  { label: "Total balance", value: "BALANCE" },
  { label: "Saved this year", value: "FLOW" },
];

export const DEFAULT_SAVINGS_GOAL = {
  name: "",
  targetAmount: 0,
  targetDate: new Date(),
  mode: MODE_OPTIONS[0],
  accountIds: [] as number[],
};
